import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appNumberLimitTo]',
    standalone: true
})
export class NumberLimitToDirective {
	constructor(
		private el: ElementRef,
		private control: NgControl
	) {}

	@Input('appNumberLimitTo') limitTo;

	@HostListener('input', ['$event']) onEvent($event) {
		const val = this.el.nativeElement.value;
		const limit = +this.limitTo;
		this.control.control.setValue(val.replace(/[^0-9]/g, '').substring(0, limit));
	}
}
